type DraftWithIdentity = {
  id?: string;
  // Imported drafts do not have server ids yet, so local keys let modal saves
  // replace the original local item after create returns a real id.
  documentKey?: string;
  personaKey?: string;
};

export function createLocalDraftKey(prefix: string): string {
  const randomId =
    typeof crypto !== "undefined" && "randomUUID" in crypto
      ? crypto.randomUUID()
      : Math.random().toString(36).slice(2);
  return `${prefix}-${randomId}`;
}

function replaceSavedDraft<T extends DraftWithIdentity>(
  drafts: T[],
  saved: T,
  keyField: "documentKey" | "personaKey",
): T[] {
  const idx = drafts.findIndex((draft) => {
    if (saved[keyField] && draft[keyField] === saved[keyField]) return true;
    return !!saved.id && draft.id === saved.id;
  });
  if (idx === -1) return [...drafts, saved];
  const next = drafts.slice();
  next[idx] = saved;
  return next;
}

export function replaceSavedPersonaDraft<T extends DraftWithIdentity>(
  drafts: T[],
  saved: T,
): T[] {
  return replaceSavedDraft(drafts, saved, "personaKey");
}

export function replaceSavedDocumentDraft<T extends DraftWithIdentity>(
  drafts: T[],
  saved: T,
): T[] {
  return replaceSavedDraft(drafts, saved, "documentKey");
}

export function buildPartialImportSaveMessage(message: string): string {
  return [
    "Some imported items were saved before this failed.",
    "Fix the issue and retry; saved items will be reused instead of recreated.",
    message,
  ].join(" ");
}
